import moment from "moment";

export const VALOR_VACIO = "-";

/**
 * Fecha DD/MM/YYYY, "-" si es nula o inválida
 */
export const formatFecha = (valor) => {
    if (!valor) return VALOR_VACIO;
    const fecha = moment(valor);
    return fecha.isValid() ? fecha.format("DD/MM/YYYY") : VALOR_VACIO;
};

/**
 * Fecha y hora DD/MM/YYYY HH:mm, "-" si es nula o inválida
 */
export const formatFechaHora = (valor) => {
    if (!valor) return VALOR_VACIO;
    const fecha = moment(valor);
    return fecha.isValid() ? fecha.format("DD/MM/YYYY HH:mm") : VALOR_VACIO;
};

/**
 * Cantidad con el 0 visible; "-" solo si es null/undefined
 */
export const formatCantidad = (valor) =>
    valor === null || valor === undefined ? VALOR_VACIO : valor;

/**
 * Texto o "-" si está vacío
 */
export const formatTexto = (valor) => valor || VALOR_VACIO;

const ESCAPES_HTML = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" };

/**
 * Escapa los caracteres HTML de un texto (Toast.js renderiza el mensaje como HTML)
 */
export const escaparHtml = (valor) =>
    String(valor ?? "").replace(/[&<>"']/g, (caracter) => ESCAPES_HTML[caracter]);
